import React from 'react';
import TlGreenWavePage from '../TlGreenWavePage';

/**
 * TlGreenWaveControls Component
 * This component wraps the TL Green Wave page and manages its visibility
 * based on whether the module is activated from the ModuleSlider
 */
function TlGreenWaveControls({
  isActive,
  isDrawing,
  setIsDrawing,
  polygonPoints,
  trafficLights,
  isAddingManualPoint,
  setIsAddingManualPoint,
  onLoadTrafficLights,
  onClearAll,
  isLoadingCarica,
  isSelecting,
  setIsSelecting,
  selectedLights,
  onRemoveLight,
  onClearSelection,
  onStartDraw,
  onTrafficLightStateChange,
  persistedSemaforiConfig,
  setPersistedSemaforiConfig,
  persistedLinksConfig,
  setPersistedLinksConfig,
  persistedVelocity,
  setPersistedVelocity,
  openConfigModalRequest,
  onConfigModalRequestConsumed,
  isEditing,
  onStartEdit,
}) {
  if (!isActive) {
    return null;
  }

  return (
    <TlGreenWavePage
      isDrawing={isDrawing}
      setIsDrawing={setIsDrawing}
      polygonPoints={polygonPoints}
      trafficLights={trafficLights}
      isAddingManualPoint={isAddingManualPoint}
      setIsAddingManualPoint={setIsAddingManualPoint}
      onLoadTrafficLights={onLoadTrafficLights}
      onClearAll={onClearAll}
      isLoadingCarica={isLoadingCarica}
      isSelecting={isSelecting}
      setIsSelecting={setIsSelecting}
      selectedLights={selectedLights}
      onRemoveLight={onRemoveLight}
      onClearSelection={onClearSelection}
      onStartDraw={onStartDraw}
      onTrafficLightStateChange={onTrafficLightStateChange}
      persistedSemaforiConfig={persistedSemaforiConfig}
      setPersistedSemaforiConfig={setPersistedSemaforiConfig}
      persistedLinksConfig={persistedLinksConfig}
      setPersistedLinksConfig={setPersistedLinksConfig}
      persistedVelocity={persistedVelocity}
      setPersistedVelocity={setPersistedVelocity}
      openConfigModalRequest={openConfigModalRequest}
      onConfigModalRequestConsumed={onConfigModalRequestConsumed}
      isEditing={isEditing}
      onStartEdit={onStartEdit}
    />
  );
}

export default TlGreenWaveControls;
